export const API_ENDPOINT = process.env.REACT_APP_API_BASE_URL
